import { BaseSuggestedRouteProps } from '@lp/features/MultiSuggest';
import { ConvertedRouteType } from '@lp/features/RoutePlanner/hooks/useConvertedRoute';
import { CurrentRouteList } from './CurrentRouteList';
import { SuggestedRouteList } from './SuggestedRouteList';

type CompareRouteListViewProps = BaseSuggestedRouteProps & {
  route: Pick<ConvertedRouteType, 'segments' | 'legs' | 'accommodationLegs'>;
};

export const CompareRouteListView = ({ taskId, chainNumber, route }: CompareRouteListViewProps) => (
  <div className="flex w-full overflow-hidden">
    <CurrentRouteList segments={route.segments} legs={route.legs} accommodationLegs={route.accommodationLegs} />
    <SuggestedRouteList taskId={taskId} chainNumber={chainNumber} />
  </div>
);
